import axios from 'axios'
//const url = 'http://localhost:8090/'
//const url = process.env.SERVER_URI//'https://api.gpdf.com.br/apiprevida/ivertex/'
const url = 'https://api.grupoparque.com.br/api-consulta-ivertex/'
export const http = axios.create({
     baseURL: url, 
}) 

http.defaults.timeout = 8500;

http.interceptors.response.use(function (response) {
     return response;
   }, function (error) {
     return Promise.reject(error);
   });


export default {
     url,
}